export default {
  // Hero
  hero_badge: 'Knowledge Hub & Research Directory',
  hero_title: 'USFans Spreadsheet — Find, Compare & Research Resources',
  hero_subtitle:
    'Explore organized USFans spreadsheet resources, product information, seller research, shipping guides, reviews, comparisons and practical tutorials — all in one place, designed to make your research faster and easier.',
  hero_cta_primary: 'usfans spreadsheet',
  hero_cta_secondary: 'buy it now',
  hero_hint: 'Browse products by category or continue to the main website',

  // Trust / value bar
  trust_1_title: 'Organized Resources',
  trust_1_desc: 'Find useful information in one structured place.',
  trust_2_title: 'Research Faster',
  trust_2_desc: 'Compare products, sellers and resources without wasting time.',
  trust_3_title: 'Updated Guides',
  trust_3_desc: 'Practical guides covering spreadsheets, shipping and warehouse info.',
  trust_4_title: 'Safety First',
  trust_4_desc: 'Learn how to evaluate links, sellers and information before deciding.',

  // Category section
  category_section_title: 'Browse Products by Category',
  category_section_subtitle:
    'Pick a category to explore related products directly on the main website.',
  category_dropdown_label: 'Choose a category',
  category_dropdown_placeholder: 'Select a category…',
  category_viewAll: 'View all categories',

  // What is
  what_title: 'What Is a USFans Spreadsheet?',
  what_body:
    'A USFans Spreadsheet is a structured way to organize and research product, seller and resource information. Instead of searching through scattered pages, you can use organized spreadsheet resources to discover information, compare options and continue your research more efficiently.',
  what_cta: 'Explore the USFans Spreadsheet Guide',

  // Guides
  guides_title: 'Popular USFans Spreadsheet Guides',
  guides_subtitle:
    'Start with these practical guides to understand spreadsheets, research and comparisons.',
  guide_1_title: 'What Is a USFans Spreadsheet?',
  guide_1_desc: 'A clear introduction to spreadsheets and how they help organize research.',
  guide_2_title: 'How to Use a USFans Spreadsheet',
  guide_2_desc: 'Step-by-step tips for browsing, comparing and organizing resources.',
  guide_3_title: 'USFans Spreadsheet Directory',
  guide_3_desc: 'An overview of the main resource areas and categories.',
  guide_4_title: 'USFans Spreadsheet Seller Guide',
  guide_4_desc: 'What to check before trusting a seller or product link.',
  guide_5_title: 'USFans Product Research',
  guide_5_desc: 'How to compare products and categories efficiently.',
  guide_6_title: 'USFans Shipping Cost Guide',
  guide_6_desc: 'Understand what can influence shipping costs and methods.',
  guides_viewAll: 'View All Guides',

  // Pillar articles
  pillar_title: 'USFans Spreadsheet Pillar Articles',
  pillar_subtitle:
    'Explore our complete library of in-depth guides covering spreadsheets, products, sellers, shipping, coupons, warehouse information, reviews and safety.',

  // Reviews / Shipping / Legit cards
  info_review_title: 'USFans Review',
  info_review_desc:
    'Explore an independent overview of USFans, including features, usability, potential advantages and important considerations.',
  info_shipping_title: 'USFans Shipping Cost',
  info_shipping_desc:
    'Learn what can influence shipping costs: methods, package weight, destination and other variables.',
  info_legit_title: 'Is USFans Legit?',
  info_legit_desc:
    'Understand what you should verify before using a platform, seller, link or service.',
  info_cta: 'Explore USFans Guides',

  // Comparison
  compare_title: 'Compare Before You Decide',
  compare_subtitle:
    'Use these dimensions to think about what matters most for your research.',
  compare_col_feature: 'Feature',
  compare_col_spreadsheet: 'Spreadsheet Research',
  compare_col_seller: 'Seller Research',
  compare_r1_label: 'Information depth',
  compare_r1_a: 'High',
  compare_r1_b: 'Medium',
  compare_r2_label: 'Ease of use',
  compare_r2_a: 'Easy',
  compare_r2_b: 'Moderate',
  compare_r3_label: 'Best for',
  compare_r3_a: 'Detailed research',
  compare_r3_b: 'Verifying sellers',

  // Safety
  safety_title: 'USFans Safety Center',
  safety_body:
    'Before using any spreadsheet, product link or seller information, take time to verify the source and understand potential risks. Our Safety Center provides practical guidance for checking links, sellers, product information and payment-related risks.',
  safety_cta: 'Visit Safety Center',

  // FAQ
  faq_title: 'Frequently Asked Questions',
  faq_subtitle: 'Quick answers to the most common questions about USFans Spreadsheet.',
  faq_q1: 'What is a USFans Spreadsheet?',
  faq_a1:
    'A USFans Spreadsheet is a structured way to organize and research product, seller and resource information in one place.',
  faq_q2: 'How do I use a USFans Spreadsheet?',
  faq_a2:
    'Start by picking a category or guide, compare the resources, and follow links to the main website when you are ready to explore further.',
  faq_q3: 'Is USFans legit?',
  faq_a3:
    'Always independently verify sellers, links and product details before making any decision or purchase.',
  faq_q4: 'How much does USFans shipping cost?',
  faq_a4:
    'Shipping costs depend on method, package weight and destination. Check the main website for current shipping details.',
  faq_q5: 'Where can I find USFans coupons?',
  faq_a5:
    'Discounts and offers change often, so check the main website directly for current promotions.',
  faq_q6: 'What is the USFans warehouse?',
  faq_a6:
    'The warehouse relates to how products are stored and shipped. Verify the latest information on the main website.',
  faq_q7: 'How can I check a USFans seller?',
  faq_a7:
    'Review product details, compare options and verify information independently before trusting any seller or link.',

  // Final CTA
  final_title: 'Ready to Explore USFans Spreadsheet Resources?',
  final_body:
    'Start with our organized USFans Spreadsheet guides, comparisons and research resources, then continue to the main website when you are ready to explore further.',
  final_cta_primary: 'Explore USFans Spreadsheet',
  final_cta_secondary: 'Visit Main Website',

  // Footer
  footer_tagline:
    'An independent informational resource for USFans Spreadsheet guides, categories, reviews and research.',
  footer_resources: 'Resources',
  footer_company: 'Company',
  footer_legal: 'Legal',
  footer_guides: 'Guides',
  footer_reviews: 'Reviews',
  footer_shipping: 'Shipping',
  footer_safety: 'Safety',
  footer_faq: 'FAQ',
  footer_about: 'About',
  footer_editorial: 'Editorial Policy',
  footer_contact: 'Contact',
  footer_privacy: 'Privacy Policy',
  footer_terms: 'Terms',
  footer_disclaimer: 'Disclaimer',
  footer_languages: 'Languages',
  footer_copyright: 'USFansLink.boats — independent informational resource. All rights reserved.',
  footer_disclaimer_text:
    'USFansLink.boats is an independent informational resource. It is not the official USFans website. Always independently verify sellers, links, products, prices, shipping information and transaction details before making decisions.',

  // Category names
  category_shoes: 'Shoes',
  category_hoodies: 'Hoodies / Sweaters',
  category_tshirts: 'T-Shirts',
  category_jackets: 'Jackets',
  category_pants: 'Pants / Shorts',
  category_headwear: 'Headwear',
  category_sets: 'Sets',
  category_underwear: 'Underwear / Underpants',
  category_jersey: 'Jersey',
  category_accessories: 'Accessories',
  category_bags: 'Bags',
  category_belts: 'Belts',
  category_perfumes: 'Perfumes',
  category_other: 'Other Stuff',
};